import { Link } from 'react-router-dom';

const guides = [
  {
    icon: 'ri-file-list-3-line',
    title: 'How to Use Pandabuy Sheet',
    desc: 'Step-by-step tutorial on navigating the spreadsheet, understanding product codes, and making your first purchase with confidence.',
    link: '/article/pandabuy-spreadsheet-guide',
    isInternal: true,
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Guide',
    desc: 'Compare shipping methods, understand delivery times, and learn how to save on international shipping costs.',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
  },
  {
    icon: 'ri-image-line',
    title: 'QC Photo Guide',
    desc: 'Learn how to evaluate QC photos, spot common flaws, and decide whether to accept or return your items.',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
  },
  {
    icon: 'ri-user-star-line',
    title: 'Trusted Seller List',
    desc: 'Our verified directory of top-rated sellers with proven track records for quality and reliable shipping.',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
  },
];

export default function GuideSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Learn &amp; Shop Smarter</p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
              Latest Buying Guides
            </h2>
            <p className="mt-4 text-sm text-foreground-500 max-w-lg mx-auto">
              Master the art of smart shopping with our comprehensive guides covering everything from spreadsheet navigation to safe buying practices.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {guides.map((guide) => (
              <div key={guide.title} className="bg-background-50 rounded-lg p-6 flex flex-col">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4">
                  <i className={`${guide.icon} text-lg`}></i>
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">{guide.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-5 flex-1">{guide.desc}</p>
                {guide.isInternal ? (
                  <Link
                    to={guide.link}
                    className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mt-auto"
                  >
                    Read Guide
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </Link>
                ) : (
                  <a
                    href={guide.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mt-auto"
                  >
                    Read Guide
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-up-line text-xs"></i>
                    </span>
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}